import { GlobalApiResponse } from "app/core/models/apiResponse.interface";

export class ActionGetPastOrder {
  static readonly type = "[PASTORDER] GET PAST ORDER";
  constructor(public payload: GlobalApiResponse) {}
}
